(function () {
  "use strict";
  var root = document.getElementById("genkidama-product-problem-report");
  if (!root) return;

  var product = {
    product_id: root.dataset.productId || "",
    product_handle: root.dataset.productHandle || "",
    product_title: root.dataset.productTitle || "",
    product_url: root.dataset.productUrl || ""
  };

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function setStatus(message, kind) {
    var status = root.querySelector("[data-gkpr-status]");
    if (!status) return;
    status.textContent = message || "";
    status.dataset.kind = kind || "";
  }

  function render() {
    root.innerHTML = [
      '<div class="gkpr-wrap">',
      '  <button class="gkpr-open" type="button" aria-expanded="false">Problem melden</button>',
      '  <form class="gkpr-panel" data-gkpr-form hidden>',
      '    <label>Was stimmt mit diesem Artikel nicht?</label>',
      '    <textarea name="report_body" maxlength="2000" placeholder="Problem kurz beschreiben..."></textarea>',
      '    <div class="gkpr-row"><span data-gkpr-status></span><button type="submit">Melden</button></div>',
      '  </form>',
      '</div>'
    ].join("");
  }

  async function submit(event) {
    event.preventDefault();
    var form = event.currentTarget;
    var body = String((form.elements.report_body && form.elements.report_body.value) || "").trim();
    if (body.length < 4) {
      setStatus("Bitte kurz beschreiben.", "error");
      return;
    }
    setStatus("Wird gesendet...", "");
    try {
      var response = await fetch("/apps/genkidama/product-report", {
        method: "POST",
        credentials: "same-origin",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(Object.assign({}, product, { report_body: body }))
      });
      var data = await response.json();
      if (!response.ok || !data.ok) throw new Error(data.error || "Fehler");
      form.reset();
      setStatus("Danke, wir pruefen das.", "ok");
    } catch (err) {
      setStatus(err.message === "login_required" ? "Bitte zuerst einloggen." : "Melden fehlgeschlagen.", "error");
    }
  }

  function bind() {
    var button = root.querySelector(".gkpr-open");
    var panel = root.querySelector("[data-gkpr-form]");
    button.addEventListener("click", function () {
      var isHidden = panel.hidden;
      panel.hidden = !isHidden;
      button.setAttribute("aria-expanded", isHidden ? "true" : "false");
    });
    panel.addEventListener("submit", submit);
  }

  function addStyles() {
    if (document.getElementById("gkpr-style")) return;
    var style = document.createElement("style");
    style.id = "gkpr-style";
    style.textContent = [
      ".gkpr-wrap{margin:18px 0}",
      ".gkpr-open{border:1px solid #ff5a00;background:#fff;color:#ff5a00;border-radius:6px;padding:10px 14px;font-weight:700;cursor:pointer}",
      ".gkpr-panel{margin-top:10px;border:1px solid #ffb58c;border-radius:8px;background:#fffaf6;padding:14px;display:grid;gap:10px;max-width:560px}",
      ".gkpr-panel[hidden]{display:none}",
      ".gkpr-panel label{font-weight:700}",
      ".gkpr-panel textarea{min-height:110px;resize:vertical;border:1px solid #c9c2bd;border-radius:6px;padding:10px;font:inherit}",
      ".gkpr-row{display:flex;justify-content:space-between;gap:12px;align-items:center}",
      ".gkpr-row button{border:0;border-radius:6px;background:#ff5a00;color:#fff;font-weight:700;padding:10px 14px;cursor:pointer}",
      "[data-gkpr-status][data-kind='ok']{color:#00884a}[data-gkpr-status][data-kind='error']{color:#b42318}",
      "@media(max-width:640px){.gkpr-row{display:grid}.gkpr-row button{width:100%}}"
    ].join("");
    document.head.appendChild(style);
  }

  addStyles();
  render();
  bind();
})();
